import cn from 'classnames'
import { FlowIcon } from '@forwardflow/features/campaign-flow/components/ui/FlowIcon'
import { TCampaignKind } from '@forwardflow/features/campaign-flow/interfaces/campaign-flow.types'
import { KIND_LABEL } from '@forwardflow/features/campaign-flow/utils/describe'

const TONE: Record<TCampaignKind, string> = {
   'new-lead': 'bg-[#9F7BFF]/15 text-[#C9B3FF] border-[#9F7BFF]/30',
   revive: 'bg-[#1FB6FF]/12 text-[#8ED8FF] border-[#1FB6FF]/30',
   activity: 'bg-[#05DF72]/12 text-[#7DF0AE] border-[#05DF72]/30',
}

/** The campaign's type (new leads, cold leads or activity), the same colours as the dashboard's types. */
export const KindTag = ({
   kind,
   className,
   testId,
}: {
   kind: TCampaignKind | null | undefined
   className?: string
   testId?: string
}) =>
   kind ? (
      <span
         className={cn(
            'inline-flex items-center gap-1 h-5 px-2 rounded-full border text-[11px] font-semibold whitespace-nowrap',
            TONE[kind],
            className
         )}
         data-testid={testId}
      >
         <FlowIcon
            name={kind === 'revive' ? 'clock' : 'zap'}
            size={10}
            strokeWidth={2.4}
         />
         {KIND_LABEL[kind]}
      </span>
   ) : null
